@use "@design/design-tokens/typography/typography" as *;

.root {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.logoSlot {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.ticker {
  @include typography-v2-body-base;
  color: var(--text-default);
  overflow: hidden;
  text-overflow: ellipsis;

  &.isUpperCase {
    text-transform: uppercase;
  }
}
